import { render, staticRenderFns } from "./LazyTable.vue?vue&type=template&id=61da3cb6&"
import script from "./LazyTable.vue?vue&type=script&lang=js&"
export * from "./LazyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports